import { createAction, props } from '@ngrx/store';

export const getBuildings = createAction('[Buildings] Get');
export const storeBuildings = createAction('[Buildings] Store', props<{ list: any }>());
